var $59200d24148e983c$exports = {};
$59200d24148e983c$exports = {
    "close": `U\u{17E}daryti`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} prane\u{161}imas`,
            other: ()=>`${formatter.number(args.count)} prane\u{161}imai`
        })}.`
};


export {$59200d24148e983c$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
